export const ADD_COUPON = 'ADD_COUPON';
export const CLEAR_COUPON = 'CLEAR_COUPON';

export function reducer(state: any = {}, action) {
  switch (action.type) {
    case ADD_COUPON:
      return action.payload;
    case CLEAR_COUPON:
      return {};
    default:
      return state;
  }
}
